<template>
  <div>
    <list
      ref="refJobList"
      sort-by="PuestoId"
      :refetch-records="fetchJobs"
      refetch-records-name="puestos"
      :actions="actions"
      key-field="puestoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteJob"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refJobList = ref(null)
    /* Services */
    const {
      fetchJobs,
      deleteJob,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.job.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.job.columns.area'),
        key: 'area.nombre',
      },
      {
        label: i18n.t('humanResources.job.columns.profile'),
        key: 'perfil.nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Puesto',
        routeName: 'apps-human-resources-job-edit',
        params: ['puestoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Puesto',
        params: ['puestoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-job-add',
        label: i18n.t('Routes.JobAdd'),
        aclAction: 'create',
        aclResource: 'Puesto',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refJobList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchJobs,
      deleteJob,
    }
  },
}
</script>
